module.exports = __webpack_public_path__ + "media/Video 157b.9529b7ff.mp4";